(() => {
  const normalize = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const score = (title, query) => {
    const t = normalize(title), q = normalize(query);
    if (!t || !q) return -1;
    if (t === q) return 100;
    if (t.includes(q) || q.includes(t)) return 90;
    const words = q.split(' ').filter(w => w.length > 2);
    return words.reduce((n,w)=>n+(t.includes(w)?1:0),0);
  };
  async function resolveLink(el) {
    const query = el.dataset.pisgahProductQuery;
    if (!query || el.dataset.pisgahResolved) return;
    el.dataset.pisgahResolved = '1';
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show`;
      const res = await fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const data = await res.json();
      const products = data?.resources?.results?.products || [];
      if (!products.length) return;
      const best = products.slice().sort((a,b)=>score(b.title,query)-score(a.title,query))[0];
      if (best?.url && score(best.title,query) > 0) el.href = best.url;
    } catch (_) { /* retain safe search fallback */ }
  }
  const resolveAll = () => document.querySelectorAll('[data-pisgah-product-query]').forEach(resolveLink);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resolveAll);
  else resolveAll();
  document.addEventListener('shopify:section:load', resolveAll);
})();
